import { Component, Input } from '@angular/core';
import { OperationType } from '@primatoo-ms-organization';
import { NgSwitch, NgSwitchCase } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pt-operation-type-badge-view',
  standalone: true,
  template: `
    <ng-container [ngSwitch]='operationType'>
      <ng-container *ngSwitchCase='OT.CREATE'>
                    <span class='badge rounded-pill ot-badge ot-create'
                    >{{ "ENUMS.OPERATION_TYPE.CREATE" | translate }}</span>
      </ng-container>
      <ng-container *ngSwitchCase='OT.UPDATE'>
                    <span class='badge rounded-pill ot-badge ot-update'
                    >{{ "ENUMS.OPERATION_TYPE.UPDATE" | translate }}</span>
      </ng-container>
      <ng-container *ngSwitchCase='OT.DELETE'>
                    <span class='badge rounded-pill ot-badge ot-delete'
                    >{{ "ENUMS.OPERATION_TYPE.DELETE" | translate }}</span>
      </ng-container>
      <ng-container *ngSwitchCase='OT.APPROVED'>
                    <span class='badge rounded-pill ot-badge ot-approved'
                    >{{ "ENUMS.OPERATION_TYPE.APPROVED" | translate }}</span>
      </ng-container>
      <ng-container *ngSwitchCase='OT.NOT_STARTED'>
                    <span class='badge rounded-pill ot-badge ot-not-started'
                    >{{ "ENUMS.OPERATION_TYPE.NOT_STARTED" | translate }}</span>
      </ng-container>
      <ng-container *ngSwitchCase='OT.WORKING'>
                    <span class='badge rounded-pill ot-badge ot-working'
                    >{{ "ENUMS.OPERATION_TYPE.WORKING" | translate }}</span>
      </ng-container>
    </ng-container>
  `,
  imports: [
    NgSwitchCase,
    TranslateModule,
    NgSwitch
  ],
  styles: [`
    .ot-badge {
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      padding: 3px 6px 3px 6px !important;
      width: fit-content;
      margin: 5px 0;
    }

    .ot-working {
      background-color: #ffc107;
      color: #333333;
    }

    .ot-not-started {
      background-color: #6c757d;
      color: #333333;
    }

    .ot-approved {
      background-color: #155724;
      color: #ffffff;
    }

    .ot-delete {
      background-color: #dc3545;
      color: #333333;
    }

    .ot-update {
      background-color: #0dcaf0;
      color: #333333;
    }

    .ot-create {
      background-color: #198754;
      color: #ffffff;
    }
  `]
})
export class OperationTypeBadgeViewerComponent {
  @Input() operationType?: OperationType;
  protected readonly OT = OperationType;
}
